import { Box } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import LimitedNavigation from '@/components/navbar/limited-navigation';
import { Toaster } from '@/components/ui/toaster';

export default function LimitLayout() {
  return (
    <Box minH={'100vh'} w='full' bgColor='secondary.500'>
      <LimitedNavigation />
      <Box mt={{ md: 4 }}>
        <Outlet />
        <Toaster />
      </Box>
    </Box>
  );
}
